import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {LookupService} from "../services/lookup.service";
import {ErrorService} from "../services/error.service";
import {ManageOrganisationService} from "../services/manage-organisation.service";

@Injectable()
export class OrganisationProfileResolver {

    constructor(
        private lookupService: LookupService,
        private errorService: ErrorService,
        private manageOrganisationService: ManageOrganisationService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let organisationReference = route.paramMap.get('organisationReference');

        return this.lookupService
            .getOrganisationProfile(organisationReference)
            .pipe(
                tap( () => {
                    this.manageOrganisationService.setOrganisationReference(organisationReference)
                }),
                catchError( err => {
                    this.errorService.logRoutingError(err)
                    return EMPTY;
                })
            );
    }
}
